import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const LanguageSwitcher = () => {
  const location = useLocation();
  const isRo = location.pathname.startsWith('/ro');

  const enPath = isRo ? location.pathname.replace(/^\/ro/, '') || '/' : location.pathname;
  const roPath = isRo ? location.pathname : '/ro' + (location.pathname === '/' ? '' : location.pathname);

  return (
    <div className="flex items-center gap-1 bg-white/5 border border-white/10 rounded-full p-1">
      <Link
        to={enPath}
        className={`px-3 py-1 rounded-full text-xs font-semibold transition-all duration-200 ${
          !isRo ? 'bg-brand-accent text-brand-dark' : 'text-gray-400 hover:text-white'
        }`}
      >
        EN
      </Link>
      <Link
        to={roPath}
        className={`px-3 py-1 rounded-full text-xs font-semibold transition-all duration-200 ${
          isRo ? 'bg-brand-accent text-brand-dark' : 'text-gray-400 hover:text-white'
        }`}
      >
        RO
      </Link>
    </div>
  );
};

export default LanguageSwitcher;